import styled from 'styled-components';

export const StyledForm = styled.form`
  display: flex;
  flex-flow: column;

  label {
    margin-bottom: 0;
  }
`;

export default {
  StyledForm,
};
